import { get, post } from "./api";

export async function connectApp(projectId: string, app: string, postUrl: string) {
  const { data } = await post({
    path: `/apps/${app}/connect`,
    data: { postUrl },
  });
  return data;
}

export async function saveAppSettings(app: string, settings: any) {
  const { data } = await post({
    path: `/apps/${app}/settings`,
    data: settings,
  });
  return data;
}

export async function getAppLinks() {
  const { data } = await get({ path: `/apps` });
  return data;
}

export async function getAppLink(appId) {
  const { data } = await get({ path: `/apps/${appId}` });
  return data;
}

export async function getHubspotField(objectType) {
  const { data } = await get({ path: `/apps/hubspot/fields/${objectType}` });
  return data;
}

export async function getJiraFields() {
  const { data } = await get({ path: `/jira/fields` });
  return data;
}

export async function getSlackChannels() {
  const { data } = await get({ path: `/slack/channels` });
  return data;
}

export async function pingMailchimp() {
  const { data } = await get({ path: `/apps/mailchimp/ping` });
  return data;
}

export async function getMailchimpAudienceList() {
  const { data } = await get({ path: `/apps/mailchimp/lists` });
  return data;
}

export async function getCurrentGoogleOwner() {
  const { data } = await get({ path: `/google/owner` });
  return data;
}

export async function getCurrentAzureOwner() {
  const { data } = await get({ path: `/azure/owner` });
  return data;
}

export async function getCurrentFacebookMe() {
  const { data } = await get({ path: `/apps/facebook/me` });
  return data;
}

export async function getCurrentFacebookPages() {
  const { data } = await get({ path: `/apps/facebook/pages` });
  return data;
}

export async function activateFacebookPage(pageId: string) {
  const { data } = await post({
    path: `/apps/facebook/pages/${pageId}/activate`,
    data: {},
  });
  return data;
}

export async function getCurrentInstagramMe() {
  const { data } = await get({ path: `/apps/instagram/me` });
  return data;
}

export async function getCurrentInstagramPages() {
  const { data } = await get({ path: `/apps/instagram/pages` });
  return data;
}

export async function activateInstagramPage(pageId: string) {
  const { data } = await post({
    path: `/apps/instagram/pages/${pageId}/activate`,
    data: {},
  });
  return data;
}

export async function getCurrentTwitterMe() {
  const { data } = await get({ path: `/apps/twitter/me` });
  return data;
}

export async function getCurrentLinkedInMe() {
  const { data } = await get({ path: `/apps/linkedin/me` });
  return data;
}

export async function getCurrentLinkedInPages() {
  const { data } = await get({ path: `/apps/linkedin/pages` });
  return data;
}

export async function getCurrentThreadsMe() {
  const { data } = await get({ path: `/apps/threads/me` });
  return data;
}

export async function signIn(app = "", redirectUrl = "") {
  const { data } = await get({
    path: `/${app}/login`,
    params: { redirect_url: redirectUrl },
  });
  return data;
}

export async function login(username, password) {
  const { data } = await post({
    path: `/auth/login`,
    data: { username, password },
  });
  return data;
}

export async function generatePassword(userId) {
  const { data } = await post({ path: `/users/${userId}/generate-password` });
  return data;
}

export async function getGoogleTenant(email: string) {
  const { data } = await post({ path: `/google/tenant`, data: { email } });
  return data;
}

export function openLink(url) {
  const a = document.createElement("a");
  a.href = url;
  a.setAttribute("target", "_parent");
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
